module.exports = __webpack_public_path__ + "static/media/bowserjr_0.4fdb47cd.png";